var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SnackbarMultiple',{ref:"snackbar",attrs:{"top":"","right":"","dark":"","max-items":10,"delay":500,"timeout":10000}})}
var staticRenderFns = []

export { render, staticRenderFns }